<template>
  <el-container>
    <el-main style="padding: 0; display: flex">
      <div style="width: 500px">
        <span>批量完工扫描</span>
        <el-divider />
        <el-form
          ref="form"
          style="width: 500px"
          :model="model"
          class="form"
          :rules="ruleValidate"
          label-width="80px"
          @submit.native.prevent
        >
          <el-form-item label="关联编号" prop="refBillNo">
            <el-input
              ref="refBillNoInput"
              v-model.trim="model.refBillNo"
              placeholder="请扫描关联编号"
              size="mini"
              @keyup.enter.native="refBillNoInput"
            />
          </el-form-item>
          <el-form-item label="完工数量" prop="quantity">
            <el-input v-model.trim="model.quantity" placeholder="请输入完工数量" size="mini" />
          </el-form-item>
          <el-form-item v-if="bindVehicleType" label="载具编号" prop="vehicleNo">
            <el-input v-model.trim="model.vehicleNo" placeholder="请扫描载具编号" size="mini" />
          </el-form-item>
          <el-form-item>
            <el-button type="info" @click="reset">重置</el-button>
            <el-button type="primary" :loading="submitLoading" @click="scanHandle">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="esopFile" v-loading="pdfLoading" style="flex: 1; margin-left: 40px">
        <pdf-preview :pdf-url="esopFile" :page-num="esopPageNo" />
      </div>
    </el-main>
  </el-container>
</template>

<script>
import PdfPreview from "@/components/PdfPreview";
export default {
  components: {
    PdfPreview,
  },

  data() {
    return {
      submitLoading: false,
      bindVehicleType: "",
      pdfLoading: false,
      model: {
        refBillNo: "",
        quantity: "",
        vehicleNo: "",
      },
      esopFile: "",
      esopPageNo: "",
      ruleValidate: {
        refBillNo: [{ required: true, message: "请扫描工单号_批次号", trigger: "blur" }],
        quantity: [
          { required: true, message: "请输入完工数量", trigger: "change" },
          {
            pattern: /^[1-9]\d*$/,
            message: "只能输入大于0的整数",
            trigger: "change",
          },
        ],
        vehicleNo: [{ required: true, message: "请扫描载具编号", trigger: "change" }],
      },
    };
  },

  mounted() {
    this.$refs.refBillNoInput.focus();
  },

  methods: {
    // 扫描关联编号查询ESOP文件、是否需要绑定载具(0：不绑定载具，1：绑定载具，2：需要载具但不绑定)
    refBillNoInput() {
      if (this.model.refBillNo) {
        this.pdfLoading = true;
        this.$http
          .get("basic", `batchComplete/info?refBillNo=${this.model.refBillNo}`)
          .then((resp) => {
            if (resp.success) {
              this.esopFile = resp.data.esopFile;
              this.esopPageNo = +resp.data.esopPageNo;
              this.bindVehicleType = resp.data.bindVehicleType;
            }
            this.pdfLoading = false;
          })
          .catch(() => {
            this.pdfLoading = false;
          });
      }
    },

    // 确认
    scanHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          this.$http
            .post("basic", "batchComplete/complete", this.model)
            .then((resp) => {
              if (resp.success) {
                this.$message.success("批量完工成功");
                this.reset();
              }
              this.submitLoading = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },

    // 重置
    reset() {
      this.$refs["form"].resetFields();
      this.$refs.refBillNoInput.focus();
    },
  },
};
</script>
